import { IonApp, IonCol, IonContent, IonLoading, IonPage } from "@ionic/react";
import BackButtonTitle from "components/mobile-components/Common/BackButtonTitle";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Payment from "services/Payment";
import LeaveDetailsCard from "components/mobile-components/Employees/LeaveDetailsCard";

export default function LeaveDetailsPage() {
	let { id } = useParams();
	let [loader, setLoader] = useState(true);
	const ekkLanguage = useSelector((state) => state.lan.lan);
	let [leaveDetails, setLeaveDetails] = useState({});

	const getLeaveDetails = async () => {
		let response = await Payment.getLeaveDetails(id);
		if (response.success) {
			setLoader(false);
			setLeaveDetails(response.results);
		}
	};

	useEffect(() => {
		getLeaveDetails();
	}, []);

	return (
		<IonApp>
			<IonPage>
				<IonContent>
					<BackButtonTitle title='Leave Request Details' />

					<section className='px-2 pt-20'>
						{loader ? (
							<IonLoading isOpen={true} />
						) : (
							<>
								{leaveDetails?.id ? (
									<LeaveDetailsCard
										collection={leaveDetails}
										getLeaveDetails={getLeaveDetails}
									/>
								) : (
									<>
										<IonCol size='2'></IonCol>
										<IonCol size='8'>
											<div
												className='text-center flex items-center justify-center'
												style={{ height: "calc(100vh - 420px)" }}>
												<div>
													<img
														className='m-auto mb-[10px] mt-5'
														src='/assets/images/not-found-file.png'
														alt='emptyCard'
													/>
													<p className='text-16 font-normal text-222222 mb-[35px]'>
														{ekkLanguage.orderList.notFound}
													</p>
												</div>
											</div>
										</IonCol>
									</>
								)}
							</>
						)}
					</section>
				</IonContent>
			</IonPage>
		</IonApp>
	);
}
